/**
 * * Тип истории изменений очередности задач
 */
enum OrderTaskHistoryTypeEnum {
  /**
   * * Добавление в очередность
   */
  Attach = 0,
  /**
   * * Исключение из очередности
   */
  Detach = 1,
  /**
   * * Удаление задачи
   */
  Remove = 2,
  /**
   * * Перемещение выше
   */
  MoveUpper = 3,
  /**
   * * Перемещение ниже
   */
  MoveLower = 4,
}
export default OrderTaskHistoryTypeEnum;
